import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DialogThjodskraFirmDetails } from 'app/dialogs/thjodskra/firm-details/dialog-thjodskra-firm-details';
import { DialogThjodskraPersonDetails } from 'app/dialogs/thjodskra/person-details/dialog-thjodskra-person-details';
import { formatDate } from 'app/helpers/formatDate';
import { formatSsn } from 'app/helpers/formatSsn';
import { sortCompare } from 'app/helpers/sortCompare';
import { ExposedListPublicRegistryCompaniesRes } from 'app/interfaces/responses/Exposed/exposedListPublicRegistryCompaniesRes';
import { ExposedListPublicRegistryPersonsRes } from 'app/interfaces/responses/Exposed/exposedListPublicRegistryPersonsRes';
import { PublicRegistryService } from 'app/services/api/publicregistry/publicregistry.service';

@Component({
    selector: 'app-thjodskra',
    templateUrl: './thjodskra.component.html',
    styleUrls: ['./thjodskra.component.scss'],
})
export class ThjodskraComponent implements OnInit {
    selectedPanelIndex = 0;
    selectedPanel: string = '';
    fetchedDate: string = null;

    //#region Einstaklingar

    einstaklingarPageSize: number = 10;
    einstaklingarPageNumber: number = 0;
    einstaklingarTotalNumber: number = 0;
    einstaklingarOrgColumns: string[] = ['nafn', 'kennitala', 'heimili', 'postnumer', 'fjolskyldunumer'];
    einstaklingarDisplayedData: MatTableDataSource<ExposedListPublicRegistryPersonsRes> = new MatTableDataSource();
    @ViewChild('einstaklingarDisplayedDataPaginator')
    einstaklingarDisplayedDataPaginator: MatPaginator;
    einstaklingarFetched = false;
    einstaklingarLoading = false;
    einstaklingarForm: UntypedFormGroup;

    initEinstaklingarForm() {
        this.einstaklingarForm = this.formBuilder.group({
            einstaklingarFilterNafn: new UntypedFormControl(''),
            einstaklingarFilterKennitala: new UntypedFormControl(''),
            einstaklingarFilterFjolskyldunumer: new UntypedFormControl(''),
            einstaklingarFilterHeimilisfang: new UntypedFormControl(''),
        });
        this.getEinstaklingarUrlParameters();
    }

    einstaklingarPageChanged(event: PageEvent) {
        this.einstaklingarPageSize = event.pageSize;
        this.einstaklingarPageNumber = event.pageIndex;
        this.einstaklingarFetch();
    }

    einstaklingarFetch() {
        this.fetchedDate = formatDate(new Date().toString());
        this.einstaklingarFetched = true;
        this.einstaklingarLoading = true;

        this.publicRegistryService
            .listPersons({
                address: this.einstaklingarForm.get('einstaklingarFilterHeimilisfang').value,
                name: this.einstaklingarForm.get('einstaklingarFilterNafn').value,
                familyNumber: this.einstaklingarForm.get('einstaklingarFilterFjolskyldunumer').value,
                postalCode: null,
                ssn: this.einstaklingarForm.get('einstaklingarFilterKennitala').value,
            })
            .subscribe((res) => {
                this.einstaklingarDisplayedData.data = res;
                this.einstaklingarTotalNumber = res.length > 0 ? res.length : 0;
                this.einstaklingarLoading = false;
            });
        this.einstaklingarUpdateUrl();
    }

    einstaklingarUpdateUrl() {
        var einstaklingarNafn = this.einstaklingarForm.get('einstaklingarFilterNafn').value ?? '';
        var einstaklingarKennitala = this.einstaklingarForm.get('einstaklingarFilterKennitala').value ?? '';
        var einstaklingarFjolskyldunumer = this.einstaklingarForm.get('einstaklingarFilterFjolskyldunumer').value ?? '';
        var einstaklingarHeimilisfang = this.einstaklingarForm.get('einstaklingarFilterHeimilisfang').value ?? '';

        let queryParams: Params = {};
        let hasQueryParams: boolean = false;

        if (einstaklingarNafn != '') {
            queryParams.nafn = btoa(einstaklingarNafn);
            hasQueryParams = true;
        }

        if (einstaklingarKennitala != '') {
            queryParams.kennitala = einstaklingarKennitala;
            hasQueryParams = true;
        }

        if (einstaklingarFjolskyldunumer != '') {
            queryParams.fjolskyldunumer = einstaklingarFjolskyldunumer;
            hasQueryParams = true;
        }

        if (einstaklingarHeimilisfang != '') {
            queryParams.heimilisfang = btoa(einstaklingarHeimilisfang);
            hasQueryParams = true;
        }

        if (hasQueryParams) {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams,
            });
        }
    }

    getEinstaklingarUrlParameters() {
        this.route.queryParams.subscribe((params) => {
            if (this.selectedPanelIndex == 0) {
                var einstaklingarFjolskyldunumer = params.fjolskyldunumer ?? '';
                var einstaklingarNafn = params.nafn ?? '';
                var einstaklingarKennitala = params.kennitala ?? '';
                var einstaklingarHeimilisfang = params.heimilisfang ?? '';

                try {
                    einstaklingarNafn = atob(einstaklingarNafn);
                    einstaklingarHeimilisfang = atob(einstaklingarHeimilisfang);
                } catch {}

                this.einstaklingarForm.setValue({
                    einstaklingarFilterNafn: einstaklingarNafn,
                    einstaklingarFilterKennitala: einstaklingarKennitala,
                    einstaklingarFilterFjolskyldunumer: einstaklingarFjolskyldunumer,
                    einstaklingarFilterHeimilisfang: einstaklingarHeimilisfang,
                });

                if (
                    !(
                        einstaklingarFjolskyldunumer == '' &&
                        einstaklingarKennitala == '' &&
                        einstaklingarNafn == '' &&
                        einstaklingarHeimilisfang == ''
                    )
                ) {
                    this.einstaklingarFetch();
                }
            }
        });
    }

    openEinstaklingarFamilyNumberTab(fjolskyldunumerValue) {
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['/thjodskra-og-fyrirtaekjaskra/einstaklingar'], {
                queryParams: { fjolskyldunumer: fjolskyldunumerValue },
            })
        );
        window.open(url, '_blank');
    }

    einstaklingarRevertAllChanges() {
        this.einstaklingarForm.get('einstaklingarFilterNafn').setValue('');
        this.einstaklingarForm.get('einstaklingarFilterKennitala').setValue('');
        this.einstaklingarForm.get('einstaklingarFilterFjolskyldunumer').setValue('');
        this.einstaklingarForm.get('einstaklingarFilterHeimilisfang').setValue('');
        this.einstaklingarFetched = false;
        this.router.navigate(['/thjodskra-og-fyrirtaekjaskra/einstaklingar']);
    }

    einstaklingarSortData(sort: Sort) {
        const data = this.einstaklingarDisplayedData.data.slice();
        if (!sort.active || sort.direction === '') {
            this.einstaklingarDisplayedData.data = data;
            return;
        }

        this.einstaklingarDisplayedData.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'nafn':
                    return sortCompare(a.name, b.name, isAsc);
                case 'kennitala':
                    return sortCompare(a.ssn, b.ssn, isAsc);
                case 'heimili':
                    return sortCompare(a.address, b.address, isAsc);
                case 'postnumer':
                    return sortCompare(a.postalCode, b.postalCode, isAsc);
                case 'fjolskyldunumer':
                    return sortCompare(a.familyNumber, b.familyNumber, isAsc);
                default:
                    return 0;
            }
        });
    }

    viewPersonDetails(element) {
        const dialogRef = this.dialog.open(DialogThjodskraPersonDetails, {
            autoFocus: false,
            restoreFocus: false,
            width: '650px',
            disableClose: true,
            data: {
                data: element,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    viewFirmDetails(element) {
        const dialogRef = this.dialog.open(DialogThjodskraFirmDetails, {
            autoFocus: false,
            restoreFocus: false,
            width: '650px',
            disableClose: true,
            data: {
                data: element,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    //#endregion

    //#region Fyrirtæki

    fyrirtaekiPageSize: number = 10;
    fyrirtaekiPageNumber: number = 0;
    fyrirtaekiTotalNumber: number = 0;
    fyrirtaekiOrgColumns: string[] = ['nafn', 'kennitala', 'postnumer', 'heimili', 'atvinnugrein', 'rekstrarform'];
    fyrirtaekiDisplayedData: MatTableDataSource<ExposedListPublicRegistryCompaniesRes> = new MatTableDataSource();
    @ViewChild('fyrirtaekiDisplayedDataPaginator')
    fyrirtaekiDisplayedDataPaginator: MatPaginator;
    fyrirtaekiFetched = false;
    fyrirtaekiLoading = false;
    fyrirtaekiForm: UntypedFormGroup;

    initfyrirtaekiForm() {
        this.fyrirtaekiForm = this.formBuilder.group({
            fyrirtaekiFilterNafn: new UntypedFormControl(''),
            fyrirtaekiFilterKennitala: new UntypedFormControl(''),
            fyrirtaekiFilterPostnumer: new UntypedFormControl(''),
            fyrirtaekiFilterHeimilisfang: new UntypedFormControl(''),
            fyrirtaekiFilterAtvinnugrein: new UntypedFormControl(''),
            fyrirtaekiFilterRekstrarform: new UntypedFormControl(''),
        });
        this.getFyrirtaekiUrlParameters();
    }

    fyrirtaekiFetch() {
        this.fetchedDate = formatDate(new Date().toString());
        this.fyrirtaekiFetched = true;
        this.fyrirtaekiLoading = true;
        this.publicRegistryService
            .listCompanies({
                IDNumber: this.fyrirtaekiForm.get('fyrirtaekiFilterKennitala').value,
                Address: this.fyrirtaekiForm.get('fyrirtaekiFilterHeimilisfang').value,
                Name: this.fyrirtaekiForm.get('fyrirtaekiFilterNafn').value,
                IndustryCode: this.fyrirtaekiForm.get('fyrirtaekiFilterAtvinnugrein').value,
                PostalCode: this.fyrirtaekiForm.get('fyrirtaekiFilterPostnumer').value,
                BusinessFormNew: this.fyrirtaekiForm.get('fyrirtaekiFilterRekstrarform').value,
            })
            .subscribe((res) => {
                this.fyrirtaekiDisplayedData.data = res;
                this.fyrirtaekiTotalNumber = res.length;
                this.fyrirtaekiLoading = false;
            });
        this.fyrirtaekiUpdateUrl();
    }

    fyrirtaekiUpdateUrl() {
        var fyrirtaekiNafn = this.fyrirtaekiForm.get('fyrirtaekiFilterNafn').value ?? '';
        var fyrirtaekiHeimilisfang = this.fyrirtaekiForm.get('fyrirtaekiFilterHeimilisfang').value ?? '';
        var fyrirtaekiKennitala = this.fyrirtaekiForm.get('fyrirtaekiFilterKennitala').value ?? '';
        var fyrirtaekiPostnumer = this.fyrirtaekiForm.get('fyrirtaekiFilterPostnumer').value ?? '';
        var fyrirtaekiAtvinnugrein = this.fyrirtaekiForm.get('fyrirtaekiFilterAtvinnugrein').value ?? '';
        var fyrirtaekiRekstrarform = this.fyrirtaekiForm.get('fyrirtaekiFilterRekstrarform').value ?? '';

        let queryParams: Params = {};
        let hasQueryParams: boolean = false;

        if (fyrirtaekiNafn != '') {
            queryParams.nafnFyrirtaekis = btoa(fyrirtaekiNafn);
            hasQueryParams = true;
        }

        if (fyrirtaekiHeimilisfang != '') {
            queryParams.heimilisfang = btoa(fyrirtaekiHeimilisfang);
            hasQueryParams = true;
        }

        if (fyrirtaekiKennitala != '') {
            queryParams.kennitala = fyrirtaekiKennitala;
            hasQueryParams = true;
        }

        if (fyrirtaekiPostnumer != '') {
            queryParams.postnumer = fyrirtaekiPostnumer;
            hasQueryParams = true;
        }

        if (fyrirtaekiAtvinnugrein != '') {
            queryParams.atvinnugrein = fyrirtaekiAtvinnugrein;
            hasQueryParams = true;
        }

        if (fyrirtaekiRekstrarform != '') {
            queryParams.rekstrarform = fyrirtaekiRekstrarform;
            hasQueryParams = true;
        }

        if (hasQueryParams) {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams,
            });
        }
    }

    getFyrirtaekiUrlParameters() {
        this.route.queryParams.subscribe((params) => {
            if (this.selectedPanelIndex == 1) {
                var fyrirtaekiNafn = params.nafnFyrirtaekis ?? '';
                var fyrirtaekiKennitala = params.kennitala ?? '';
                var fyrirtaekiPostnumer = params.postnumer ?? '';
                var fyrirtaekiHeimilisfang = params.heimilisfang ?? '';
                var fyrirtaekiAtvinnugrein = params.atvinnugrein ?? '';
                var fyrirtaekiRekstrarform = params.rekstrarform ?? '';

                try {
                    fyrirtaekiNafn = atob(fyrirtaekiNafn);
                    fyrirtaekiHeimilisfang = atob(fyrirtaekiHeimilisfang);
                } catch {}

                this.fyrirtaekiForm.setValue({
                    fyrirtaekiFilterNafn: fyrirtaekiNafn,
                    fyrirtaekiFilterKennitala: fyrirtaekiKennitala,
                    fyrirtaekiFilterPostnumer: fyrirtaekiPostnumer,
                    fyrirtaekiFilterHeimilisfang: fyrirtaekiHeimilisfang,
                    fyrirtaekiFilterAtvinnugrein: fyrirtaekiAtvinnugrein,
                    fyrirtaekiFilterRekstrarform: fyrirtaekiRekstrarform,
                });

                if (
                    !(
                        fyrirtaekiNafn == '' &&
                        fyrirtaekiKennitala == '' &&
                        fyrirtaekiPostnumer == '' &&
                        fyrirtaekiHeimilisfang == '' &&
                        fyrirtaekiAtvinnugrein == '' &&
                        fyrirtaekiRekstrarform == ''
                    )
                ) {
                    this.fyrirtaekiFetch();
                }
            }
        });
    }

    fyrirtaekiRevertAllChanges() {
        this.fyrirtaekiForm.get('fyrirtaekiFilterNafn').setValue('');
        this.fyrirtaekiForm.get('fyrirtaekiFilterKennitala').setValue('');
        this.fyrirtaekiForm.get('fyrirtaekiFilterPostnumer').setValue('');
        this.fyrirtaekiForm.get('fyrirtaekiFilterHeimilisfang').setValue('');
        this.fyrirtaekiForm.get('fyrirtaekiFilterAtvinnugrein').setValue('');
        this.fyrirtaekiForm.get('fyrirtaekiFilterRekstrarform').setValue('');
        this.fyrirtaekiFetched = false;
        this.router.navigate(['thjodskra-og-fyrirtaekjaskra/fyrirtaeki']);
    }

    fyrirtaekiSortData(sort: Sort) {
        const data = this.fyrirtaekiDisplayedData.data.slice();
        if (!sort.active || sort.direction === '') {
            this.fyrirtaekiDisplayedData.data = data;
            return;
        }

        this.fyrirtaekiDisplayedData.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'nafn':
                    return sortCompare(a.name, b.name, isAsc);
                case 'kennitala':
                    return sortCompare(a.idNumber, b.idNumber, isAsc);
                case 'postnumer':
                    return sortCompare(a.postalCode, b.postalCode, isAsc);
                case 'heimili':
                    return sortCompare(a.address, b.address, isAsc);
                case 'atvinnugrein':
                    return sortCompare(a.industryCode, b.industryCode, isAsc);
                case 'rekstrarform':
                    return sortCompare(a.businessFormNew, b.businessFormNew, isAsc);
                default:
                    return 0;
            }
        });
    }

    //#endregion

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private formBuilder: UntypedFormBuilder,
        public dialog: MatDialog,
        public publicRegistryService: PublicRegistryService
    ) {
        this.findCorrectTabBasedOnUrl();
        this.initPanelBasedOnUrl();
        this.initEinstaklingarForm();
        this.initfyrirtaekiForm();
    }

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.einstaklingarDisplayedData.paginator = this.einstaklingarDisplayedDataPaginator;
        this.fyrirtaekiDisplayedData.paginator = this.fyrirtaekiDisplayedDataPaginator;
    }

    findCorrectTabBasedOnUrl() {
        try {
            this.selectedPanel = this.route.snapshot.paramMap.get('tab');
        } catch {}
    }

    initPanelBasedOnUrl() {
        if (this.selectedPanel == 'einstaklingar') {
            this.selectedPanelIndex = 0;
        } else if (this.selectedPanel == 'fyrirtaeki') {
            this.selectedPanelIndex = 1;
        } else {
            this.location.go('/thjodskra-og-fyrirtaekjaskra/einstaklingar');
            this.selectedPanel = 'einstaklingar';
            this.selectedPanelIndex = 0;
        }
    }

    tabChanged(event: MatTabChangeEvent) {
        if (event.index == 0) {
            this.selectedPanelIndex = 0;
            this.location.go('/thjodskra-og-fyrirtaekjaskra/einstaklingar');
            this.einstaklingarRevertAllChanges();
        } else if (event.index == 1) {
            this.selectedPanelIndex = 1;
            this.location.go('/thjodskra-og-fyrirtaekjaskra/fyrirtaeki');
            this.fyrirtaekiRevertAllChanges();
        }
    }

    formatSsn(s) {
        return formatSsn(s);
    }
}
